"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("reflect-metadata");

var PrimitiveTypeEnum_1 = require("./PrimitiveTypeEnum");

var PropertyTypeDefinition_1 = require("./PropertyTypeDefinition");

function ra_property() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return function (target, propertyKey) {
    var type;
    var rename;
    var options = PropertyTypeOptions.None;

    for (var _i = 0, args_1 = args; _i < args_1.length; _i++) {
      var arg = args_1[_i];

      if (typeof arg === 'string') {
        rename = arg;
      } else if (typeof arg === 'function') {
        type = arg;
      } else if (typeof arg === 'number') {
        options = arg;
      }
    } // If no explicit type was given check the Meta Data generated by TypeScript


    if (type === undefined) {
      var systemMetaData = Reflect.getMetadata('design:type', target, propertyKey);

      if (systemMetaData) {
        type = PrimitiveTypeEnum_1.typeForTypeName(systemMetaData.name) || systemMetaData;
      } else {
        type = undefined;
      }
    } else if (!PrimitiveTypeEnum_1.isPrimitiveTypeEnum(type)) {
      // Check if the Class name belongs to a primitive class (e.g. `String`, `Number`)
      type = PrimitiveTypeEnum_1.typeForTypeName(type.name) || type;
    }

    var propertyTypeDefinition = new PropertyTypeDefinition_1.PropertyTypeDefinition(type, options, propertyKey, rename);
    Reflect.defineMetadata(PropertyTypeDefinition_1.metadataKey, propertyTypeDefinition, target, propertyKey); // If `rename` is given, also register the metadata for it

    if (rename) {
      Reflect.defineMetadata(PropertyTypeDefinition_1.metadataKey, propertyTypeDefinition, target, rename);
    }
  };
}

exports.ra_property = ra_property;
var PropertyTypeOptions;

(function (PropertyTypeOptions) {
  PropertyTypeOptions[PropertyTypeOptions["None"] = 0] = "None";
  PropertyTypeOptions[PropertyTypeOptions["Multiple"] = 1] = "Multiple";
  PropertyTypeOptions[PropertyTypeOptions["NoSerialization"] = 4] = "NoSerialization";
  PropertyTypeOptions[PropertyTypeOptions["Lazy"] = 2] = "Lazy";
})(PropertyTypeOptions = exports.PropertyTypeOptions || (exports.PropertyTypeOptions = {}));